<template>
  <div class="bind-phone-page">
    <!-- 已绑定手机号的提示 -->
    <div v-if="isBound" class="bound-status">
      <h2>手机号已绑定</h2>
      <p>您的手机号已经绑定成功</p>
      <button @click="goBack" class="back-btn">返回</button>
    </div>
    
    <!-- 绑定手机号的表单 -->
    <div v-else class="bind-form">
      <h2>绑定手机号</h2>
      <p>请绑定您的手机号以继续使用</p>
      <input 
        v-model="phone" 
        type="text" 
        placeholder="请输入手机号" 
        class="phone-input" 
      />
      <button @click="handleBindPhone" class="bind-btn">绑定</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { bindPhone } from '../api'
import { getToken } from '@/utils/utils'

const router = useRouter()
const route = useRoute()
const phone = ref('')
const isBound = ref(false)

async function handleBindPhone() {
  if (!/^1\d{10}$/.test(phone.value)) {
    alert('请输入正确的手机号')
    return
  }
  
  try {
    await bindPhone({ phone: phone.value })
    localStorage.setItem('bindPhoneV2', '1')
    alert('绑定成功')
    // 绑定成功后直接显示已绑定状态
    isBound.value = true
  } catch (e) {
    // alert('绑定失败')
  }
}

function goBack() {
  // 在微信公众号环境中关闭当前窗口回到微信
  // eslint-disable-next-line no-undef
  if (typeof WeixinJSBridge !== 'undefined') {
    // eslint-disable-next-line no-undef
    WeixinJSBridge.call('closeWindow')
  } else {
    // 如果不是在微信环境中，尝试其他方式关闭窗口
    try {
      window.close()
    } catch (e) {
      // 如果window.close()失败，则返回上一页
      router.go(-1)
    }
  }
}

onMounted(() => {
  // 检查是否已登录
  const token = getToken()
  if (!token) {
    router.replace('/login')
    return
  }
  
  // 检查URL参数，判断是否显示已绑定状态
  const status = route.query.status
  if (status === 'bound') {
    isBound.value = true
  } else {
    // 检查本地存储，判断是否已绑定
    const bindPhoneFlag = localStorage.getItem('bindPhoneV2')
    if (bindPhoneFlag === '1') {
      isBound.value = true
    }
  }
})
</script>

<style scoped>
.bind-phone-page {
  max-width: 400px;
  margin: 100px auto;
  padding: 20px;
  text-align: center;
}

.bound-status {
  background: #f8f9fa;
  padding: 40px 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.bound-status h2 {
  color: #28a745;
  margin-bottom: 10px;
}

.bound-status p {
  color: #666;
  margin-bottom: 20px;
}

.bind-form {
  background: #fff;
  padding: 40px 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.bind-form h2 {
  margin-bottom: 10px;
  color: #333;
}

.bind-form p {
  color: #666;
  margin-bottom: 30px;
}

.phone-input {
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.bind-btn, .back-btn {
  width: 100%;
  padding: 12px;
  background: #42b983;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.bind-btn:hover, .back-btn:hover {
  background: #369870;
}

.back-btn {
  background: #6c757d;
}

.back-btn:hover {
  background: #5a6268;
}
</style> 